import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {NotasInseridas} from '@/model/resource/NotasInseridas'

@HttpExclude()
export class NotasInseridasCollection extends PageCollection<NotasInseridas> {
  constructor() {
    super(NotasInseridas)
  }

  monthly = false

  get populatedMounts() {
    const populatedMounts = Array<boolean>(12).fill(false)
    if (this.items.length > 0) {
      let amountPopulatedMounts = 0
      let respIndex = 0
      while (respIndex < this.items.length && amountPopulatedMounts < 12) {
        this.items[respIndex].qtdNotasMes?.forEach(notaMes => {
          if (notaMes.mes && !populatedMounts[notaMes.mes - 1]) {
            populatedMounts[notaMes.mes - 1] = true
            amountPopulatedMounts++
          }
        })
        respIndex++
      }
    }
    return populatedMounts
  }

  queryAsPage() {
    if (this.monthly) {
      return this.listNotasInseridasMonthly()
    }
    return this.listNotasInseridasWeekly()
  }

  async listNotasInseridasMonthly() {
    return await Request.get(`/admin/notas-inseridas/monthly`, {
      params: this.params,
    })
      .name('listNotasInseridasMonthly')
      .as(this)
      .getResponse()
  }

  async listNotasInseridasMonthlyCsv() {
    return await Request.get(`/admin/notas-inseridas/monthly`, {
      params: this.params,
    })
      .name('listNotasInseridasMonthlyCsv')
      .as(this)
      .getResponse()
  }

  async listNotasInseridasWeekly() {
    return await Request.get(`/admin/notas-inseridas/weekly`, {
      params: this.params,
    })
      .name('listNotasInseridasWeekly')
      .as(this)
      .getResponse()
  }
}
